import { ReactElement } from 'react';
import clsx from 'clsx';
import { ValueLabel, variables } from '../common';
import { IRequestStatus, show } from '.';
import { left, right, fold } from 'fp-ts/lib/Either';
import {
  map as lmap,
  compose as lcompose,
  isEmpty as lisEmpty,
} from 'lodash/fp';
import { Button, styled } from '@mui/material';

export const renderStack =
  (
    s: any,
    disableOperationsHelpDsk: boolean,
    selectedRequestIds?: number[],
    toggleRequestSelection?: (payload: IRequestStatus) => void,
    confirmCancelRequests?: () => void
  ) =>
  (properties: ValueLabel<keyof IRequestStatus>[]) =>
    lcompose(
      fold(
        () => <article>Empty</article>,

        requests => (
          <Article className={s.wrapper}>
            {lmap<IRequestStatus, ReactElement>(a => (
              <Article
                key={a.requestId}
                className={clsx(s.wrapper, s.itemWrapper)}>
                {lmap<ValueLabel<keyof IRequestStatus>, ReactElement>(
                  ({ value, label }) => (
                    <Line key={value}>
                      <Label>{label}:</Label>
                      <Line>
                        {show(
                          a,
                          toggleRequestSelection,
                          selectedRequestIds
                        )(value)}
                      </Line>
                    </Line>
                  )
                )(properties)}
              </Article>
            ))(requests)}
            <Button
              onClick={confirmCancelRequests}
              disabled={
                lisEmpty(selectedRequestIds) || disableOperationsHelpDsk
              }
              variant="contained">
              Cancel Request
            </Button>
          </Article>
        )
      ),
      (requests: IRequestStatus[]) =>
        requests.length === 0 ? left(requests) : right(requests)
    );

const Article = styled('article')(() => ({
  display: 'flex',
  flexDirection: 'column',

  '&>*+*': {
    marginTop: '0.5rem',
  },

  paddingBottom: '0.5rem',
  borderBottom: variables.cardBorder,
}));

const Label = styled('span')(() => ({ fontWeight: 700 }));

const Line = styled('span')(() => ({
  '&>*+*': {
    marginLeft: '1rem',
  },
}));
